import { render, staticRenderFns } from "./TheModalTratamientoProceso.vue?vue&type=template&id=7b2a766e&"
import script from "./TheModalTratamientoProceso.vue?vue&type=script&lang=js&"
export * from "./TheModalTratamientoProceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports